import React from "react";
import BtnRight from "../../common/ButtonRight";
import Breadcrumb from "../../common/Breadcrumb";
import Quiz from "../../../Assets/img/elearning/quiz.png";
import { Link } from "react-router-dom";
import { SlArrowRight } from "react-icons/sl";

export default function ElearningCourses(props) {
  const elearning = [
    {
      img: Quiz,
      title: "Quiz Module",
      subTitle: "A simple Quiz Module that stores data and returns result",
      para: "",
      link: "https://iamnikitamallya.github.io/quiz_storyline_360/",
    },
  ];
  return (
    <div>
      <div className={`${props.mode}`}>
        <Breadcrumb
          title="E-Learning Courses"
          to1="/works/frontend"
          label1="Front-end Development"
          icon1={<SlArrowRight />}
          to2="/works/emails"
          label2="Responsive Email Design"
          icon2={<SlArrowRight />}
          to3="/works/uxui"
          label3="UX/UI"
          icon3={<SlArrowRight />}
          to4="/works/digital-assets"
          label4="Digital Asset"
          icon4={<SlArrowRight />}
        />
      </div>
      <div className={`section pb-5 pt-7 works ${props.mode}`}>
        <div className="row">
          <div className="col-12">
            {/* Aakruthi Project Start Here*/}
            {elearning.map((item) => (
              <div className="row mob-mb-3">
                <div className="col-md-6">
                  <Link to={item.link} rel="noreferrer">
                    <div className="card">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="figmaprototype mobile-app"
                      ></img>
                      {/* <video src={qisetnaVideo} autoPlay loop muted></video> */}
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 d-flex-works">
                  <div className="items">
                    <div className="title">
                      <h3>
                        {item.title} <span>{item.subTitle}</span>
                      </h3>
                      <p>{item.para}</p>
                    </div>
                    <BtnRight
                      to={item.link}
                      label="View"
                      icon={<SlArrowRight />}
                      className="icon primary-button"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
